module.exports = "<div id=\"affiliate-portal\" class=\"clearfix\">\n  <sidebar></sidebar>\n  <div id=\"content\" class=\"view-container view-frame view-fade-in\" ui-view>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/app/app.html
// module id = 542
// module chunks = 1